import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaUser, FaEnvelope, FaLock, FaPhone, FaMapMarkerAlt, FaIdCard, FaCheckCircle } from 'react-icons/fa';
import './Registo.css';
import API_BASE_URL from '../../config/api';

const Registo = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    telefone: '',
    dataNascimento: '',
    nif: '',
    morada: '',
    codigoPostal: '',
    localidade: '',
    password: '',
    confirmPassword: '',
    aceitaTermos: false,
    aceitaPrivacidade: false,
    aceitaComunicacoes: false
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
    if (error) setError('');
  };

  const handleNextStep = (e) => {
    e.preventDefault();
    if (step < 3) {
      setStep(step + 1);
    }
  };

  const handlePrevStep = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError('As passwords não coincidem!');
      return;
    }

    if (!formData.aceitaTermos || !formData.aceitaPrivacidade) {
      setError('Deve aceitar os termos e condições e a política de privacidade.');
      return;
    }

    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{}|;:'",.<>?/]).{8,}$/;
    if (!passwordRegex.test(formData.password)) {
      setError('A password não cumpre todos os requisitos de segurança.');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/api/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: formData.email,
          password: formData.password,
          confirmPassword: formData.confirmPassword,
          firstName: formData.firstName,
          lastName: formData.lastName,
          phone: formData.telefone,
          birthDate: formData.dataNascimento || null,
          nif: formData.nif,
          address: formData.morada,
          postalCode: formData.codigoPostal,
          city: formData.localidade
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Registration failed');
      }

      navigate('/registo-sucesso');
    } catch (err) {
      console.error('Registration error:', err);
      setError(err.message || 'Erro ao criar conta. Por favor, tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="registo-page">
      <div className="registo-container">
        <div className="progress-steps">
          <div className="progress-line"></div>
          <div className={`progress-step ${step >= 1 ? 'active' : ''} ${step > 1 ? 'completed' : ''}`}>
            <div className="step-number">{step > 1 ? '✓' : '1'}</div>
            <div className="step-label">Dados Pessoais</div>
          </div>
          <div className={`progress-step ${step >= 2 ? 'active' : ''} ${step > 2 ? 'completed' : ''}`}>
            <div className="step-number">{step > 2 ? '✓' : '2'}</div>
            <div className="step-label">Morada</div>
          </div>
          <div className={`progress-step ${step >= 3 ? 'active' : ''}`}>
            <div className="step-number">3</div>
            <div className="step-label">Credenciais</div>
          </div>
        </div>

        <div className="registo-form-wrapper">
          <form onSubmit={step === 3 ? handleSubmit : handleNextStep}>
            {step === 1 && (
              <div className="form-step">
                <h2>Dados Pessoais</h2>
                <p className="step-description">Preencha os seus dados para criar a sua conta de sócio</p>

                <div className="form-row">
                  <div className="form-group">
                    <label>Primeiro Nome *</label>
                    <input
                      type="text"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      placeholder="Primeiro nome"
                      required
                      disabled={loading}
                    />
                  </div>

                  <div className="form-group">
                    <label>Último Nome *</label>
                    <input
                      type="text"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      placeholder="Último nome"
                      required
                      disabled={loading}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Email *</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="seu.email@exemplo.com"
                      required
                      disabled={loading}
                    />
                  </div>

                  <div className="form-group">
                    <label>Telefone *</label>
                    <input
                      type="tel"
                      name="telefone"
                      value={formData.telefone}
                      onChange={handleChange}
                      placeholder="+351 912 345 678"
                      required
                      disabled={loading}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Data de Nascimento *</label>
                    <input
                      type="date"
                      name="dataNascimento"
                      value={formData.dataNascimento}
                      onChange={handleChange}
                      required
                      disabled={loading}
                    />
                  </div>

                  <div className="form-group">
                    <label>NIF *</label>
                    <input
                      type="text"
                      name="nif"
                      value={formData.nif}
                      onChange={handleChange}
                      placeholder="123456789"
                      maxLength="9"
                      required
                      disabled={loading}
                    />
                  </div>
                </div>
              </div>
            )}

            {step === 2 && (
              <div className="form-step">
                <h2>A Sua Morada</h2>
                <p className="step-description">Indique onde reside para efeitos de faturação e contacto</p>

                <div className="form-row" style={{ gridTemplateColumns: '1fr' }}>
                  <div className="form-group">
                    <label>Morada *</label>
                    <input
                      type="text"
                      name="morada"
                      value={formData.morada}
                      onChange={handleChange}
                      placeholder="Rua, número, andar"
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Código Postal *</label>
                    <input
                      type="text"
                      name="codigoPostal"
                      value={formData.codigoPostal}
                      onChange={handleChange}
                      placeholder="4490-XXX"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Localidade *</label>
                    <input
                      type="text"
                      name="localidade"
                      value={formData.localidade}
                      onChange={handleChange}
                      placeholder="Póvoa de Varzim"
                      required
                    />
                  </div>
                </div>
              </div>
            )}

            {step === 3 && (
              <div className="form-step">
                <h2>Credenciais</h2>
                <p className="step-description">Defina a sua porta de entrada no portal CDP</p>

                {error && (
                  <div className="error-message">
                    {error}
                  </div>
                )}

                <div className="form-row">
                  <div className="form-group">
                    <label>Password *</label>
                    <input
                      type="password"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      placeholder="••••••••"
                      required
                      disabled={loading}
                    />
                  </div>

                  <div className="form-group">
                    <label>Confirmar Password *</label>
                    <input
                      type="password"
                      name="confirmPassword"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                      placeholder="••••••••"
                      required
                      disabled={loading}
                    />
                  </div>
                </div>

                <div className="password-requirements">
                  <div className={`requirement-item ${formData.password.length >= 8 ? 'met' : ''}`}>
                    {formData.password.length >= 8 ? <FaCheckCircle /> : <div className="circle-placeholder" />}
                    <span>Mínimo 8 caracteres</span>
                  </div>
                  <div className={`requirement-item ${/[A-Z]/.test(formData.password) ? 'met' : ''}`}>
                    {/[A-Z]/.test(formData.password) ? <FaCheckCircle /> : <div className="circle-placeholder" />}
                    <span>Maiúscula</span>
                  </div>
                  <div className={`requirement-item ${/[0-9]/.test(formData.password) ? 'met' : ''}`}>
                    {/[0-9]/.test(formData.password) ? <FaCheckCircle /> : <div className="circle-placeholder" />}
                    <span>Número</span>
                  </div>
                  <div className={`requirement-item ${/[!@#$%^&*()_+\-=[\]{}|;:'",.<>?/]/.test(formData.password) ? 'met' : ''}`}>
                    {/[!@#$%^&*()_+\-=[\]{}|;:'",.<>?/]/.test(formData.password) ? <FaCheckCircle /> : <div className="circle-placeholder" />}
                    <span>Símbolo</span>
                  </div>
                </div>

                <div className="terms-section">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      name="aceitaTermos"
                      checked={formData.aceitaTermos}
                      onChange={handleChange}
                      required
                    />
                    <span>Aceito os <a href="#">Termos e Condições</a></span>
                  </label>

                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      name="aceitaPrivacidade"
                      checked={formData.aceitaPrivacidade}
                      onChange={handleChange}
                      required
                    />
                    <span>Aceito a Política de Privacidade</span>
                  </label>
                </div>
              </div>
            )}

            <div className="form-navigation">
              {step > 1 && (
                <button type="button" onClick={handlePrevStep} className="btn-prev" disabled={loading}>
                  Voltar
                </button>
              )}

              {step < 3 ? (
                <button type="submit" className="btn-next" disabled={loading}>
                  Seguinte
                </button>
              ) : (
                <button type="submit" className="registo-btn-submit" disabled={loading}>
                  {loading ? 'A processar...' : 'Concluir Registo'}
                </button>
              )}
            </div>
          </form>

          <div className="login-link">
            <p>Já tem conta? <Link to="/login">Inicie sessão</Link></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Registo;